// Modules
import { useCallback } from 'react'
import axios from 'axios'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Helpers
import { getAuthorizationHeader, getTeam, getToken } from 'helpers/authentication'
import { getTheme } from 'helpers/system'

// Constants
import { LOGIN_URL } from 'constants/environment'

// Hook: External > Navigate with parameters
function useNavigateWithParameters () {
	// Data
	const { addNotice } = useNotices()

	// Function (Memoized)
	const navigateWithParameters = useCallback(async (url, tokenType) => {
		const redirectURL = !!url ? new URL(url) : null
		try {
			let token = getToken()
			if (!token) {
				const { data } = await axios({
					data: { app: tokenType },
					headers: { ...getAuthorizationHeader() },
					method: 'POST',
					url: `${LOGIN_URL}/app`
				})
				token = { accessToken: data.accessToken, refreshToken: data.refreshToken }
			}
			if (!!token.accessToken && !!token.refreshToken) {
				redirectURL.searchParams.set('token', token.accessToken)
				redirectURL.searchParams.set('refresh', token.refreshToken)
				redirectURL.searchParams.set('team', getTeam())
				redirectURL.searchParams.set('theme', getTheme())
				window.location.href = redirectURL.href
			}
		} catch (error) {
			addNotice({ code: 'client.applicationTokenFetchingError', log: error, type: 'error' })
		}
	}, [addNotice])

	// Response
	return { navigateWithParameters }
}

// Export
export default useNavigateWithParameters
